/* eslint-disable react/jsx-filename-extension */
import React from "react";
import { push } from "connected-react-router";
import moment from "moment";
import AnulateEcheckForm from "pages/echeck/EcheckActions/components/AnulateForm";
import AnulateAvalForm from "pages/echeck/ActionsAval/Index";
import RepudiateEcheckForm from "pages/echeck/EcheckActions/components/RepudiateForm";
import DepositEcheckForm from "pages/echeck/EcheckActions/components/DepositForm";
import CustodyEcheq from "pages/echeck/EcheckActions/components/CustodyForm";
import RequestReturnEcheqForm from "pages/echeck/EcheckActions/components/RequestReturnForm";
import { actions as echeckActions, types } from "reducers/echecks";
import { actions as notificationActions } from "reducers/notification";
import * as i18n from "util/i18n";
import * as config from "util/config";

const FORM_ID = "echeq";

export default function specialOptions(echeq, environmentCuit, functionAction) {
    let contextSpecialMenuActions = [];
    switch (echeq.estado) {
        case "ACTIVO": {
            if (echeq.tenencia_beneficiario_documento === environmentCuit) {
                if (echeq.cheque_caracter.toLowerCase() === "no a la orden") {
                    contextSpecialMenuActions = [
                        {
                            label: `${FORM_ID}.emit.cesion.echeq`,
                            onClick: () => functionAction("EMIT-CESION", echeq),
                        },
                        {
                            label: `${FORM_ID}.negotiate.echeq`,
                            onClick: () => functionAction("NEGOTIATE", echeq),
                        },
                        {
                            label: `${FORM_ID}.request.aval.echeq`,
                            onClick: () => functionAction("REQUEST-AVAL", echeq),
                        },
                    ];
                } else {
                    contextSpecialMenuActions = [
                        {
                            label: `${FORM_ID}.endorse.echeq`,
                            onClick: () => functionAction("ENDORSE", echeq),
                        },
                        {
                            label: `${FORM_ID}.negotiate.echeq`,
                            onClick: () => functionAction("NEGOTIATE", echeq),
                        },
                        {
                            label: `${FORM_ID}.request.aval.echeq`,
                            onClick: () => functionAction("REQUEST-AVAL", echeq),
                        },
                    ];
                }

                const defaultTZ = config.get("administration.timezone.defaultValue", "America/Argentina/Buenos_Aires");
                const fechaPago = moment(echeq.fecha_pago)
                    .tz(defaultTZ)
                    .format("YYYY-MM-DD");
                const fechaHoy = moment()
                    .tz(defaultTZ)
                    .format("YYYY-MM-DD");
                const diff = Math.abs(moment(fechaPago).diff(moment(fechaHoy), "days"));

                if ((fechaPago < fechaHoy && diff <= 30) || diff === 0) {
                    contextSpecialMenuActions = [
                        ...contextSpecialMenuActions,
                        {
                            label: `${FORM_ID}.deposit.echeq`,
                            onClick: () => functionAction("DEPOSIT", echeq),
                        },
                    ];
                } else {
                    // if (moment(echeq.fecha_pago) > moment()) {
                    contextSpecialMenuActions = [
                        ...contextSpecialMenuActions,
                        {
                            label: `${FORM_ID}.custody.echeq`,
                            onClick: () => functionAction("CUSTODY", echeq),
                        },
                    ];
                }
            }
            if (
                (echeq.emisor_cuit === environmentCuit ||
                    (echeq.total_endosos > 0 && echeq.endosos[0].emisor_documento === environmentCuit)) &&
                echeq.tenencia_beneficiario_documento !== environmentCuit
            ) {
                contextSpecialMenuActions = [
                    ...contextSpecialMenuActions,
                    {
                        label: `${FORM_ID}.request.return.echeq`,
                        onClick: () => functionAction("REQUEST-RETURN", echeq),
                    },
                ];
            }

            break;
        }
        case "ACTIVO-PENDIENTE": {
            if (
                echeq.total_endosos > 0 &&
                echeq.endosos[0].benef_documento === environmentCuit &&
                echeq.endosos[0].estado_endoso.toLowerCase() === "pendiente"
            ) {
                contextSpecialMenuActions = [
                    {
                        label: `${FORM_ID}.admit.echeq`,
                        onClick: () => functionAction("ADMIT", echeq),
                    },
                    {
                        label: `echeq.repudiate.echeq`,
                        onClick: () => functionAction("REPUDIATE", echeq),
                    },
                ];
            } else if (
                echeq.total_endosos > 0 &&
                echeq.endosos[0].emisor_documento === environmentCuit &&
                echeq.endosos[0].estado_endoso.toLowerCase() === "pendiente"
            ) {
                contextSpecialMenuActions = [
                    {
                        label: `${FORM_ID}.anulate-endorse.echeq`,
                        onClick: () => functionAction("ANULATE-ENDORSE", echeq),
                    },
                ];
            }

            break;
        }
        case "CUSTODIA": {
            const diff = moment(echeq.fecha_pago).diff(moment(), "days");
            if (echeq.tenencia_beneficiario_documento === environmentCuit && diff >= 1) {
                contextSpecialMenuActions = [
                    {
                        label: `${FORM_ID}.rescue.echeq`,
                        onClick: () => functionAction("RESCUE", echeq),
                    },
                ];
            }

            break;
        }
        case "RECHAZADO": {
            if (
                echeq.cesion_pendiente &&
                echeq.total_cesiones > 0 &&
                echeq.cesiones[0].cesionario_documento === environmentCuit
            ) {
                contextSpecialMenuActions = [
                    {
                        label: `${FORM_ID}.admit.echeq`,
                        onClick: () => functionAction("ADMIT-CESION", echeq),
                    },
                    {
                        label: `${FORM_ID}.repudiate.echeq`,
                        onClick: () => functionAction("REPUDIATE-CESION", echeq),
                    },
                ];
            } else if (
                echeq.cesion_pendiente &&
                echeq.total_cesiones > 0 &&
                echeq.cesiones[0].cedente_documento === environmentCuit
            ) {
                contextSpecialMenuActions = [
                    {
                        label: `${FORM_ID}.anulate.cesion.echeq`,
                        onClick: () => functionAction("ANULATE-CESION", echeq),
                    },
                ];
            }

            if (
                echeq.total_cesiones > 0 &&
                !echeq.certificado_emitido &&
                !echeq.re_presentar &&
                echeq.tenencia_beneficiario_documento === environmentCuit
            ) {
                contextSpecialMenuActions = [
                    ...contextSpecialMenuActions,
                    {
                        label: `${FORM_ID}.emit.cesion.echeq`,
                        onClick: () => functionAction("EMIT-CESION", echeq),
                    },
                ];
            }

            if (
                (echeq.emisor_cuit === environmentCuit ||
                    (echeq.cheque_caracter.toLowerCase() !== "no a la orden" &&
                        echeq.endosos.find((endoso) => endoso.emisor_documento === environmentCuit))) &&
                echeq.tenencia_beneficiario_documento !== environmentCuit &&
                !echeq.re_presentar &&
                !echeq.solicitando_acuerdo &&
                !echeq.cheque_acordado
            ) {
                contextSpecialMenuActions = [
                    ...contextSpecialMenuActions,
                    {
                        label: `${FORM_ID}.request.return.echeq`,
                        onClick: () => functionAction("REQUEST-RETURN", echeq),
                    },
                ];
            }

            // Antigua Solicitud de CAC
            // if (
            //     echeq.tenencia_beneficiario_documento === environmentCuit &&
            //     !echeq.certificado_emitido &&
            //     !echeq.cesion_pendiente &&
            //     !echeq.re_presentar &&
            //     !echeq.cheque_acordado &&
            //     !echeq.solicitando_acuerdo
            // ) {
            //     contextSpecialMenuActions = [
            //         ...contextSpecialMenuActions,
            //         {
            //             label: `${FORM_ID}.request.certificate.echeq`,
            //             onClick: () => functionAction("REQUEST-CERTIFICATE", echeq),
            //         },
            //     ];
            // }

            if (echeq.cheque_id === "RPQ2GDZLKVY2GLY") {
                contextSpecialMenuActions = [
                    {
                        label: `${FORM_ID}.accept.return.echeq`,
                        onClick: () => functionAction("ACCEPT-RETURN-REJECTED", echeq),
                    },
                ];
            }

            if (echeq.tenencia_beneficiario_documento === environmentCuit && echeq.solicitando_acuerdo) {
                if (!echeq.certificado_emitido) {
                    contextSpecialMenuActions = [
                        {
                            label: `${FORM_ID}.accept.return.echeq.rejected`,
                            onClick: () => functionAction("ACCEPT-RETURN-REJECTED", echeq),
                        },
                    ];
                } else {
                    contextSpecialMenuActions = [
                        {
                            label: `${FORM_ID}.accept.return.echeq`,
                            onClick: () => functionAction("ACCEPT-RETURN", echeq),
                        },
                        {
                            label: `${FORM_ID}.repudiate.return.echeq`,
                            onClick: () => functionAction("REPUDIATE-RETURN", echeq),
                        },
                    ];
                }
            }

            if (echeq.cuit_solic_devol === environmentCuit && echeq.solicitando_acuerdo) {
                contextSpecialMenuActions = [
                    {
                        label: `${FORM_ID}.anulate.return.echeq`,
                        onClick: () => functionAction("ANULATE-RETURN", echeq),
                    },
                ];
            }

            if (
                echeq.tenencia_beneficiario_documento === environmentCuit &&
                !echeq.certificado_emitido &&
                !echeq.re_presentar &&
                !echeq.cesion_pendiente
            ) {
                contextSpecialMenuActions = [
                    ...(contextSpecialMenuActions || []),
                    {
                        label: `${FORM_ID}.request.cac`,
                        onClick: () => functionAction("REQUEST-CAC", echeq),
                    },
                ];
            }

            break;
        }
        case "CESION-PENDIENTE": {
            if (echeq.total_cesiones > 0 && echeq.cesiones[0].cesionario_documento === environmentCuit) {
                contextSpecialMenuActions = [
                    {
                        label: `${FORM_ID}.admit.echeq`,
                        onClick: () => functionAction("ADMIT-CESION", echeq),
                    },
                    {
                        label: `${FORM_ID}.repudiate.echeq`,
                        onClick: () => functionAction("REPUDIATE-CESION", echeq),
                    },
                ];
            } else if (echeq.total_cesiones > 0 && echeq.cesiones[0].cedente_documento === environmentCuit) {
                contextSpecialMenuActions = [
                    {
                        label: `${FORM_ID}.anulate.cesion.echeq`,
                        onClick: () => functionAction("ANULATE-CESION", echeq),
                    },
                ];
            }
            break;
        }
        case "DEVOLUCION-PENDIENTE": {
            if (echeq.tenencia_beneficiario_documento === environmentCuit) {
                contextSpecialMenuActions = [
                    {
                        label: `${FORM_ID}.accept.return.echeq`,
                        onClick: () => functionAction("ACCEPT-RETURN", echeq),
                    },
                    {
                        label: `${FORM_ID}.repudiate.return.echeq`,
                        onClick: () => functionAction("REPUDIATE-RETURN", echeq),
                    },
                ];
            }
            if (echeq.cuit_solic_devol === environmentCuit) {
                contextSpecialMenuActions = [
                    {
                        label: `${FORM_ID}.anulate.return.echeq`,
                        onClick: () => functionAction("ANULATE-RETURN", echeq),
                    },
                ];
            }
            break;
        }
        case "AVAL-PENDIENTE": {
            if (echeq.tenencia_beneficiario_documento === environmentCuit) {
                contextSpecialMenuActions = [
                    {
                        label: `${FORM_ID}.anulate.aval.echeq`,
                        onClick: () => functionAction("AVAL-ANULATE", echeq),
                    },
                ];
            }
            if (echeq?.avalistas[0]?.aval_documento === environmentCuit) {
                contextSpecialMenuActions = [
                    {
                        label: `${FORM_ID}.repudiate.aval.echeq`,
                        onClick: () => functionAction("AVAL-REPUDIATE", echeq),
                    },
                    {
                        label: `${FORM_ID}.accept.aval.echeq`,
                        onClick: () => functionAction("AVAL-ADMIT", echeq),
                    },
                ];
            }
            break;
        }
        case "CADUCADO": {
            if (echeq.tenencia_beneficiario_documento === environmentCuit && !echeq.certificado_emitido) {
                contextSpecialMenuActions = [
                    {
                        label: `${FORM_ID}.request.cac`,
                        onClick: () => functionAction("REQUEST-CAC", echeq),
                    },
                ];
            }
            break;
        }
        default: {
            break;
        }
    }

    return contextSpecialMenuActions;
}

export const receivedEcheqAction = (action, echeq, dispatch, setDrawer) => {
    const echeqList = [echeq];
    if (
        action === "REQUEST-AVAL" ||
        action === "AVAL-ANULATE" ||
        action === "AVAL-REPUDIATE" ||
        action === "AVAL-ADMIT" ||
        action === "REQUEST-CAC" ||
        action === "ACCEPT-RETURN-REJECTED"
    ) {
        dispatch(echeckActions.setEchecksToDoActions({ action, echeq }));
    } else {
        dispatch(echeckActions.setEchecksToDoActions({ action, echeqList }));
    }

    switch (action) {
        case "ADMIT": {
            dispatch(push("/echecks/action/transaction/confirm"));
            break;
        }
        case "ANULATE-CESION": {
            dispatch(push("/echecks/action/transaction/confirm"));
            break;
        }
        case "REPUDIATE": {
            setDrawer({
                showDrawer: true,
                contentDrawer: <RepudiateEcheckForm />,
            });
            break;
        }
        case "DEPOSIT": {
            setDrawer({
                showDrawer: true,
                contentDrawer: (
                    <DepositEcheckForm currency={echeq?.moneda} hideDrawer={() => setDrawer({ showDrawer: false })} />
                ),
            });
            break;
        }
        case "CUSTODY": {
            setDrawer({
                showDrawer: true,
                contentDrawer: (
                    <CustodyEcheq currency={echeq?.moneda} hideDrawer={() => setDrawer({ showDrawer: false })} />
                ),
            });
            break;
        }
        case "RESCUE": {
            dispatch(push("/echecks/action/transaction/confirm"));
            break;
        }
        case "ENDORSE": {
            dispatch(push("/echecks/action/endorse"));
            break;
        }
        case "ADMIT-CESION": {
            dispatch(push("/echecks/action/transaction/confirm"));
            break;
        }
        case "REPUDIATE-CESION": {
            setDrawer({
                showDrawer: true,
                contentDrawer: <RepudiateEcheckForm />,
            });
            break;
        }
        case "EMIT-CESION": {
            dispatch(push("/echecks/action/cesion"));
            break;
        }
        case "ANULATE-ENDORSE": {
            // TODO BIBANK CHANGE benef_documento WHEN BACKEN WAS INTEGRATE

            if (echeq.total_endosos > 0 && echeq.endosos[0].benef_documento === "30576614299") {
                dispatch(
                    notificationActions.showNotification(i18n.get("anulate.endorse.message"), "info", ["echecks"]),
                );
            } else {
                setDrawer({
                    showDrawer: true,
                    contentDrawer: <AnulateEcheckForm />,
                });
            }

            break;
        }
        case "REQUEST-RETURN": {
            setDrawer({
                showDrawer: true,
                contentDrawer: <RequestReturnEcheqForm />,
            });
            break;
        }
        case "ANULATE-ECHEQ": {
            setDrawer({
                showDrawer: true,
                contentDrawer: <AnulateEcheckForm />,
            });
            break;
        }
        case "ANULATE-RETURN": {
            dispatch(push("/echecks/anulate/confirmation"));
            break;
        }
        case "REPUDIATE-RETURN": {
            dispatch(push("/echecks/action/confirmation"));
            break;
        }
        case "ACCEPT-RETURN": {
            dispatch(echeckActions.setRequestReturnSolicitanInformation(echeq.cuit_solic_devol));
            dispatch(push("/echeqs/action/return/accept"));
            break;
        }
        case "REQUEST-CERTIFICATE": {
            dispatch(push("/echecks/action/confirmation"));
            break;
        }
        case "NEGOTIATE": {
            dispatch(push("/echeqs/action/negotiate"));
            break;
        }
        case "REQUEST-AVAL": {
            dispatch(echeckActions.beneficiaryEcheq({}, types.SELECT_BENEFICIARY));
            dispatch(push("/echecks/aval/solicit"));
            break;
        }
        case "AVAL-ANULATE": {
            setDrawer({
                showDrawer: true,
                contentDrawer: <AnulateAvalForm />,
            });
            break;
        }
        case "AVAL-REPUDIATE": {
            setDrawer({
                showDrawer: true,
                contentDrawer: <AnulateAvalForm />,
            });
            break;
        }
        case "AVAL-ADMIT": {
            dispatch(push("/echecks/aval/actions/sumary"));
            break;
        }
        case "REQUEST-CAC": {
            dispatch(push("/echecks/cac/summary"));
            break;
        }
        case "ACCEPT-RETURN-REJECTED": {
            dispatch(push("/echecks/rejected/return/accept"));
            break;
        }
        default:
            break;
    }
};
